import { ColorsEnum } from "../et3-theme/colors";

const ALPHA_HAIRLINE = "14";
const ALPHA_HOVER = "0F";

export const PAGE_TITLE_WIDTH = 1550;
export const PAGE_TITLE_HEIGHT = 64;
export const PAGE_TITLE_PADDING_TOP = 10;
export const PAGE_TITLE_PADDING_BOTTOM = 14;
export const PAGE_TITLE_MARGIN_BOTTOM = 24;
export const PAGE_TITLE_ACCENT_WIDTH = 3;
export const PAGE_TITLE_ACCENT_HEIGHT = 22;
export const PAGE_TITLE_ACCENT_RADIUS = 2;
export const PAGE_TITLE_ACCENT_GAP = 12;
export const PAGE_TITLE_FONT_SIZE = 26;
export const PAGE_SUBTITLE_FONT_SIZE = 15;
export const PAGE_TITLE_GAP = 10;
export const PAGE_TITLE_ACTION_SIZE = 36;
export const PAGE_TITLE_ACTION_RADIUS = 10;
export const PAGE_TITLE_ACTION_ICON_SIZE = 16;
export const PAGE_TITLE_ACTIONS_GAP = 6;
export const PAGE_TITLE_ACTIONS_WIDTH = 96;

export const PAGE_TITLE_BORDER = `1px solid ${ColorsEnum.maastrichtBlue}${ALPHA_HAIRLINE}`;
export const PAGE_TITLE_ACTION_HOVER = `${ColorsEnum.maastrichtBlue}${ALPHA_HOVER}`;
export const PAGE_TITLE_TRANSITION =
  "background-color 160ms cubic-bezier(0.4, 0, 0.2, 1)";
